/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class PCSettings {
    public static readonly ALWAYS_REQUIRE_PIN = 'alwaysRequirePin';

    public static readonly DEFAULT_PC_PIN = 'defaultPcPin';

    public static readonly DEFAULT_SETTINGS_CHANGED = 'defaultSettingsChanged';

    public static readonly GENERIC_RATING_LIMITS = 'genericRatingLimits';

    public static readonly HIDE_ADULT = 'hideAdult';

    public static readonly HIGHEST_ALLOWED_MOVIE_RATING = 'heighestAllowedMovieRating';

    public static readonly HIGHEST_ALLOWED_TV_RATING = 'heighestAllowedTvRating';

    public static readonly PARENTAL_SETTINGS = 'parentalSettings';

    public static readonly PC_PIN = 'pcPin';

    public static readonly PC_STATUS = 'pcStatus';

    public static readonly RATING_LIMITS = 'ratingLimits';

    public static readonly RATINGS_INSTRUCTIONS = 'raingsInstructions';

    public static readonly UNRATED_MOVIE_RATING = 'unratedMovieRating';

    public static readonly UNRATED_TV_RATING = 'unratedTvRating';

    public static readonly VERIFIED_PIN_TIMESTAMP = 'verifiedPinTimestamp';

    public static readonly HEIGHEST_ALLOWED_RATINGS = 'heighestAllowedRatings';

    public static readonly UNRATED_CONTENT_ALLOWED = 'unratedContentAllowed';
}
